import type { VehicleFE } from 'domain/vehicle';
import { setSeverity } from 'helper/setSeverity';
import { flattenFeDeviations } from 'helper/vehicleV2';

import type { SearchedVehicle } from './types';

export const parseSearchedVehicles = (vehicles: VehicleFE[] | undefined): SearchedVehicle[] | undefined => {
    if (!vehicles) {
        return;
    }

    const parsedVehicles = vehicles.map(vehicle => {
        const connectivity = vehicle.connectivity.value?.value;
        return {
            name: vehicle.name,
            licensePlate: vehicle?.licensePlate,
            vin: vehicle.vin,
            connectivityStatus: connectivity
                ? {
                      state: connectivity.state,
                      expectedDisconnect: connectivity.expectDisconnection,
                  }
                : null,
            severity: setSeverity(flattenFeDeviations(vehicle).filter(d => d.state !== 'RESOLVED')),
        };
    });

    return parsedVehicles;
};
